var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAndroidSms = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.71111 0.36084C10.4183 0.36084 13.4222 3.36473 13.4222 7.07195C13.4222 10.7792 10.4183 13.7831 6.71111 13.7831C3.00389 13.7831 0 10.7792 0 7.07195C0 3.36473 3.00389 0.36084 6.71111 0.36084ZM4.85079 9.26783L3.49515 10.5832V4.91366C3.49515 4.47609 3.85218 4.11638 4.28974 4.11638H9.17543C9.61299 4.11638 9.97271 4.47609 9.97271 4.91366V8.47055C9.97271 8.90811 9.61299 9.26783 9.17543 9.26783H4.85079Z",
    fill: "#516FFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAndroidSms, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/AndroidSMS.cda95350.svg";
export { ForwardRef as ReactComponent };